export default {

    country: 'en',

    STAGE_WIDTH: null,

    STAGE_HEIGHT: null,

    STAGE_HALF_WIDTH: null,

    STAGE_HALF_HEIGHT: null,

    resolution: 1,

    config: {},

    renderer: null,

    canvasMode: false,

    input: null,

    stage: null,

    ticker: null,

    transitions: null,

    currentScene: null,

    display: null,

    saveData: null,

    audio: null,

    baseUrl: null, 
    
    firstClick: false,
    
    timeElapsed: 0,

    frameCount: 0,

    avgFPS: 0,

    timeStretch: 1,

    tempButtonTexture: null,


    //Game

    character: null,

    currentBout: 0,

    currentRound: 0,

    currentScores: {0:0, 1:0},

    currentHealth: []
}